<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import Card from '@/components(new)/UI/Cards/Card/Card.vue'

export default {
  components: {
    TitleWithRow,
    InputSelect,
    Label,
    Card
  },
  props: {
    pratica: {
      type: Object,
      required: true
    },
    nomeAba: {
      type: String,
      default: ''
    },
    // Nome da key dentro do objeto "praticas" que será salvo os dados
    nomeArraySalvar: {
      type: String,
      required: true
    },
    optionsSelect: {
      type: Array,
      required: true
    },
    label1: {
      type: String,
      default: 'Espécie florestal:'
    },
    label2: {
      type: String,
      default: 'Espaçamento:'
    },
    label3: {
      type: String,
      default: 'Qual?:'
    },
    obrigatorio: {
      type: Boolean
    },
    tituloCard: {
      type: String
    },
    tipoEspecie: {
      type: String
    }
  },

  data () {
    return {
      especieFlorestal: null,
      espacamento: null,
      outraEspecieFlorestal: null,
      nomeCientifico: null
    }
  },
  computed: {
    disableButton () {
      const isOutros = this.especieFlorestal === 'OUTROS'
      return isOutros ? (!this.outraEspecieFlorestal || !this.espacamento) : (!this.especieFlorestal || !this.espacamento)
    },
    // Utilizado para filtrar por tipoEspecie
    dados () {
      const lista = this.pratica[this.nomeArraySalvar]
      if (this.tipoEspecie) {
        return lista
          .filter(p => p.tipo === this.tipoEspecie)
          .map(({especie, espacamento, especificacao, nomeCientifico}) => {
            return {
              especie,
              espacamento,
              especificacao,
              nomeCientifico
            }
          })
      }
      return lista
    }
  },
  methods: {
    addEspecie () {
      const dadosEspecieSelecionada = this.optionsSelect.filter(a => a.id === this.especieFlorestal)
      const especie = {
        especie: this.especieFlorestal,
        espacamento: this.espacamento,
        especificacao: this.outraEspecieFlorestal,
        nomeCientifico: dadosEspecieSelecionada[0].nomeCientifico
      }
      if (this.tipoEspecie) {
        especie.tipo = this.tipoEspecie
      }
      this.pratica[this.nomeArraySalvar].push(especie)
      this.resetarCamposEspecie()
    },
    rmEspecie (prop) {
      const index = this.pratica[this.nomeArraySalvar].findIndex(e => e.especie === prop.especie)
      this.pratica[this.nomeArraySalvar].splice(index, 1)
    },
    editarEspecie (prop) {
      this.especieFlorestal = prop.especie
      this.espacamento = prop.espacamento
      this.outraEspecieFlorestal = prop.especificacao
      this.rmEspecie(prop)
    },
    resetarCamposEspecie () {
      this.especieFlorestal = null
      this.outraEspecieFlorestal = null
      this.espacamento = null
      this.nomeCientifico = null
    },
    nomeEspecie (prop) {
      return (
        this.optionsSelect.find(o => prop.especie === o.id) &&
        this.optionsSelect.find(o => prop.especie === o.id).nome
      )
    }
  }
}
</script>

<template>
  <div>
    <el-row :gutter="20">
      <InputSelect
        :label="label1"
        v-model="especieFlorestal"
        :nomeAba="nomeAba"
        :obrigatorio="pratica[nomeArraySalvar].length === 0"
        :rulesInput="pratica[nomeArraySalvar].length === 0 ? 'required' : ''"
        :multiSelect="false"
        :opcoes="optionsSelect"
        :widthColumn="8"
      />

      <validation-provider
        :rules="pratica[nomeArraySalvar].length === 0 ? 'required' : ''"
        v-slot="{ errors }"
        :name="nomeAba + '/' + label2"
      >
        <el-col :span="8">
          <Label :label="label2" :obrigatorio="pratica[nomeArraySalvar].length === 0" />
          <el-input
            :name="label2"
            v-model="espacamento"
            :class="{ 'input erro': errors.length }"
            placeholder="(m)"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>

      <el-col :span="8">
        <div class="mb-1">&nbsp;</div>
        <el-button
          :disabled="disableButton"
          round
          type="primary"
          @click="addEspecie()"
        >
          Adicionar
        </el-button>
      </el-col>
    </el-row>

    <el-row :gutter="20" v-if="especieFlorestal === 'OUTROS'">
      <validation-provider
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Outra espécie florestal`"
      >
        <el-col :span="8">
          <Label :label="label3" :obrigatorio="true" />
          <el-input
            name="Outra espécie florestal"
            v-model="outraEspecieFlorestal"
            :class="{ 'input erro': errors.length }"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>

    <el-row :gutter="20" v-if="dados.length > 0">
      <div class="flex-wrapper row">
        <div v-for="(e, i) in dados" :key="i + e.especie">
          <Card
            :objeto="{
              especie: nomeEspecie(e),
              nomeCientifico: e.nomeCientifico,
              espacamento: e.espacamento,
              especificacao: e.especificacao
            }"
            :deletar="() => rmEspecie(e)"
            :editar="() => editarEspecie(e)"
            :titulo="tituloCard"
            widthCard="400px"
          />
        </div>
      </div>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/EspecieEspacamento/EspecieEspacamento.vue